import React, { useState } from 'react';

import { FieldTimeOutlined } from '@ant-design/icons';

import RibbonButton from 'common/components/button/RibbonButton';
import ManageScheduleDownloadModal from 'common/components/modal-manage-schedule-download/ManageScheduleDownloadModal';

import Messages from 'i18n/messages/home';

const ManageScheduleDownload = (props) => {
  const { selectedFolder } = props;
  const [manageScheduleModalVisible, setManageScheduleModalVisible] =
    useState(false);

  const onClick = () => {
    setManageScheduleModalVisible(true);
  };

  const closeDownloadModalVisible = () => {
    setManageScheduleModalVisible(false);
  };

  const folderId = selectedFolder?.id;
  const disabled = !folderId || !selectedFolder?.hasSchedule;

  return (
    <div>
      <RibbonButton
        icon={<FieldTimeOutlined />}
        label={Messages.manageSchedule}
        onClick={onClick}
        disabled={disabled}
      />
      <ManageScheduleDownloadModal
        visible={manageScheduleModalVisible}
        folderId={folderId}
        onCancel={closeDownloadModalVisible}
      />
    </div>
  );
};

export default ManageScheduleDownload;
